/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_PlatformsInputs */

const id_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const ms_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const da_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme`)
};

const de_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformen`)
};

const en_us2_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const es_es2_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const es_mx2_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const fil_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Platform`)
};

const fr_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateformes`)
};

const it_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piattaforme`)
};

const hu_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformok`)
};

const nl_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const no_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformer`)
};

const pl_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy`)
};

const pt_br2_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const pt_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const ro_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme`)
};

const fi_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alustat`)
};

const sv_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformar`)
};

const vi_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng`)
};

const tr_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformlar`)
};

const cs_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy`)
};

const bg_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи`)
};

const ru_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформы`)
};

const uk_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи`)
};

const ar_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنصات`)
};

const hi_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म`)
};

const th_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตฟอร์ม`)
};

const ja_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム`)
};

const zh_cn2_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

const zh_hant1_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

const ko_items_table_platforms = /** @type {(inputs: Items_Table_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Items_Table_PlatformsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_platforms = /** @type {((inputs?: Items_Table_PlatformsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_PlatformsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_platforms(inputs)
	if (locale === "ms") return ms_items_table_platforms(inputs)
	if (locale === "da") return da_items_table_platforms(inputs)
	if (locale === "de") return de_items_table_platforms(inputs)
	if (locale === "en-US") return en_us2_items_table_platforms(inputs)
	if (locale === "es-ES") return es_es2_items_table_platforms(inputs)
	if (locale === "es-MX") return es_mx2_items_table_platforms(inputs)
	if (locale === "fil") return fil_items_table_platforms(inputs)
	if (locale === "fr") return fr_items_table_platforms(inputs)
	if (locale === "it") return it_items_table_platforms(inputs)
	if (locale === "hu") return hu_items_table_platforms(inputs)
	if (locale === "nl") return nl_items_table_platforms(inputs)
	if (locale === "no") return no_items_table_platforms(inputs)
	if (locale === "pl") return pl_items_table_platforms(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_platforms(inputs)
	if (locale === "pt") return pt_items_table_platforms(inputs)
	if (locale === "ro") return ro_items_table_platforms(inputs)
	if (locale === "fi") return fi_items_table_platforms(inputs)
	if (locale === "sv") return sv_items_table_platforms(inputs)
	if (locale === "vi") return vi_items_table_platforms(inputs)
	if (locale === "tr") return tr_items_table_platforms(inputs)
	if (locale === "cs") return cs_items_table_platforms(inputs)
	if (locale === "bg") return bg_items_table_platforms(inputs)
	if (locale === "ru") return ru_items_table_platforms(inputs)
	if (locale === "uk") return uk_items_table_platforms(inputs)
	if (locale === "ar") return ar_items_table_platforms(inputs)
	if (locale === "hi") return hi_items_table_platforms(inputs)
	if (locale === "th") return th_items_table_platforms(inputs)
	if (locale === "ja") return ja_items_table_platforms(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_platforms(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_platforms(inputs)
	return ko_items_table_platforms(inputs)
});
export { items_table_platforms as "items.table.platforms" }